"use client";

/**
 * Registers public/sw.js — the second of the two installability requirements,
 * alongside app/manifest.ts (generated per-brand; see src/lib/whitelabel/manifest.ts).
 * The service worker itself caches nothing; registering it is the whole job here.
 */
import { useEffect } from "react";

export function PwaRegister() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);
  return null;
}
